<template>
    <div>
        <input type="text" :maxlength="maxLength" :placeholder="formElement.dynamicTypeData.placeHolder" v-model="formElement.dynamicTypeData.value" required>
        <small class="has-text-grey" style="vertical-align: top;"><em>Tilgængelige tegn: {{availableCharCount}}</em></small>
        <p class="error" v-if="formElement.dynamicTypeData.isValid !== undefined && !formElement.dynamicTypeData.isValid" v-html="this.errorText" />
    </div>
</template>

<script>

export default {
  name: "kollecto-textbox",
  props: ["formElement", "userAction"],
  data() {
        return {
            errorText: "",
            maxLength: 100
        };
    },
    watch: { 
        formElement: {
            immediate: true, 
            handler (newVal, oldVal) {
                if (this.userAction === 'newregistration' || !this.userAction) {
                    if(this.formElement.dynamicTypeData.value) {
                        //do nothing..
                    }  
                    else if (this.formElement.dynamicTypeData.defaultValue) {
                        this.formElement.dynamicTypeData.value = this.formElement.dynamicTypeData.defaultValue
                    }                    
                }

                this.errorText = this.formElement.dynamicTypeData.errorText;
            }   
        }  
    },
  created() {
    if (this.userAction === "create" || !this.userAction) {
      if (this.formElement.dynamicTypeData.defaultValue) {
        this.formElement.dynamicTypeData.value = this.formElement.dynamicTypeData.defaultValue;
      }
    }
    console.log("maxLength: " +this.formElement.dynamicTypeData.maxLength);
    if (this.formElement.dynamicTypeData.maxLength && this.formElement.dynamicTypeData.maxLength > 0) {
      this.maxLength = this.formElement.dynamicTypeData.maxLength;
    }
  },
  computed: {
        availableCharCount() {
            let text = this.formElement.dynamicTypeData.value
            if (text && text.length > 0) {
                return this.maxLength - text.length
            }
            return this.maxLength
        }
    },
};
</script>
